"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderTotalContent_1 = require("./OrderTotalContent");
exports.default = OrderTotalContent_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/OrderTotalContent/index.js
// module id = 2373
// module chunks = 8